export default __webpack_public_path__ + "static/heroSectionBg-9cff140133557c8da2adb11be991d988.png";